module.exports = __webpack_public_path__ + "static/anli5.79310803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anli5.jpg
// module id = 718
// module chunks = 168707334958949